import { Box, Button, Drawer, MenuItem, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from "@mui/material";
import { returnRowType } from "./RetrunData";
import { Card } from "../../ui/Card";
import { useEffect, useState } from "react";
import { assignMultipleService, bookReturnsMethod } from "./returnApi";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import toast from "react-hot-toast";
import { api } from "../../../config/api";

const MultipleReturnsAssignDrawer = ({
  ids,
  data,
  open,
  handleClose,
}: {
  ids: GridRowSelectionModel;
  data: returnRowType[];
  open: boolean;
  handleClose: () => void;
}) => {
  const [selectedVendor, setSelectedVendor] = useState("0");
  const [tempData, setTempData] = useState(data);
  const [serviceData, setServiceData] = useState<string[]>();

  useEffect(() => {
    api
      .get("/b2c/service/code/")
      .then((data) => {
        setServiceData(data?.data?.data?.reverse());
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    setTempData(data);
  }, [open]);

  const vendor = serviceData?.findIndex((el) => el === selectedVendor);

  const handleMultipleReturns = () => {
    assignMultipleService({
      id: ids.join(","),
      mode: serviceData?.[vendor as number] as string,
      service: serviceData?.[vendor as number] as string,
    })
      .then((apiData) => {
        const finalData = apiData?.data?.data;

        if (finalData?.length === 0) {
          return toast.error("Unable to assign service!");
        }

        finalData?.map((el: { error: boolean; message: string }) => {
          if (el?.error === true) {
            toast.error(el?.message);
          }
        });

        const newTempData = [...tempData];

        newTempData.map((el, index) => {
          if (el.id == finalData[index]?.id) {
            el.amount = finalData[index]?.amount ?? "0";
            el.vendor = finalData[index]?.service ?? "--";
          }
        });

        setTempData(newTempData);

        toast.success("You can book your orders now!");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const bookAllReturns = () => {
    bookReturnsMethod(ids as string[])
      .then((data) => {
        toast.success("Returns Booked!");
      })
      .catch(error => console.log(error));
  };

  const checkIfAllVendor = () => {
    data.forEach((el) => {
      if (!el.vendor) {
        return false;
      }
    });
    return true;
  };

  const canBook = checkIfAllVendor() && selectedVendor === "0";

  return (
    <Drawer open={open} onClose={handleClose} anchor="right">
      <div className="multiple-order-assign">
        <Box
          sx={{
            padding: "10px 30px",
          }}
        >
          <Stack
            sx={{
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              marginBottom: "40px",
              flexWrap: "wrap",
              rowGap: "20px",
            }}
          >
            <Select
              value={selectedVendor}
              sx={{
                width: "180px",
                marginRight: "20px",
              }}
              onChange={(e) => setSelectedVendor(e.target.value)}
            >
              <MenuItem value={"0"}>Select Vendor</MenuItem>
              {serviceData?.map((el, index) => {
                return (
                  <MenuItem key={index} value={el}>
                    {el}
                  </MenuItem>
                );
              })}
            </Select>
            <Button
              onClick={handleMultipleReturns}
              disabled={selectedVendor === "0"}
              variant="contained"
            >
              Assign Vendor
            </Button>
            <Button
              sx={{
                marginLeft: "10px",
              }}
              onClick={bookAllReturns}
              disabled={canBook}
              variant="contained"
            >
              Book
            </Button>
          </Stack>

          <TableContainer component={Card}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>id</TableCell>
                  <TableCell>Vendor</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>From</TableCell>
                  <TableCell>Receiver</TableCell>
                  <TableCell>Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data &&
                  data?.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row?.id}</TableCell>
                      <TableCell>{row?.vendor}</TableCell>
                      <TableCell>{row?.description}</TableCell>
                      <TableCell>
                        {row?.from}-{row?.to}
                      </TableCell>
                      <TableCell>{row?.receiver}</TableCell>
                      <TableCell>{row?.amount}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    </Drawer >
  );
};

export default MultipleReturnsAssignDrawer;
